import { NotFound } from 'react-admin'

export default () => <NotFound title="Not Found" />
